<template >
  <ul v-infinite-scroll="load" :infinite-scroll-immediate="false" class="infinite-list" style="overflow: auto">
    <li v-for="(i, k) in evaArr" :key="k" class="infinite-list-item">
      <Order :formItem="i" @isShow="isShow" />
    </li>
  </ul>
</template>

<script>
import Order from "@/components/workorder/index.vue";
export default {
  components: {
    Order,
  },
  props: {
    getData: {
      type: Function,
      default: () => {
        return () => {};
      }
    }
  },
  data() {
    return {
      activeName: 'all',
      Show: false,
      load: false,
      evaArr: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {
      let pro = this.getData('evaluate');
      pro.then((res) => {
        this.evaArr.push(...res['data']);
      });
      // const evaArr = [
      //   {
      //     id:10010,
      //     company_id:10010,
      //     orderno:"O-0853-1511-2305-2349",
      //     createtime:"2023-05-15",
      //     fault:"不识别，插上后没反应，风扇不转",
      //     status:"7",
      //     is_evaluate:"0",
      //     status_text: "3",
      //     evaluate_text:"已派单",
      //     evaluate:"Evaluate 3",
      //   },
      //   {
      //     id:10010,
      //     company_id:10010,
      //     orderno:"O-0853-1511-2305-2349",
      //     createtime:"2023-05-15",
      //     fault:"不识别，插上后没反应，风扇不转",
      //     status:"7",
      //     is_evaluate:"1",
      //     status_text: "3",
      //     evaluate_text:"已派单",
      //     evaluate:"Evaluate 3",
      //   },
      // ]

    },
    isShow(value) {
      this.$emit("isShow", value);
    },
  },
};
</script>

<style scoped>
.infinite-list {
  height: calc(100% - 10px);
}
</style>